import { infiniteScrollFormBase } from "./infinite-scroll-form";

export class InfiniteScrollUtils {
    public static parseHtmlDocument(html: string): Document {
        return new DOMParser().parseFromString(html, "text/html");
    }

    public static findNextUrl(doc: Document, paginationSelector: string, nextLinkSelector: string): string | null {
        if (!(doc instanceof Document)) return null;

        const pagination = infiniteScrollFormBase.getPaginationElement(doc, paginationSelector);
        if (!(pagination instanceof HTMLElement)) return null;

        const nextLink = infiniteScrollFormBase.getNextLink(pagination, nextLinkSelector);
        if (!(nextLink instanceof HTMLAnchorElement)) return null;

        const href = nextLink.getAttribute("href");
        if (!href) return null;

        try {
            const absolute = new URL(href, globalThis.location?.href || href);
            return absolute.toString();
        } catch {
            return null;
        }
    }
}
